import { ParentState } from "@hopper-b2b/checkout";
import { assign } from "xstate";
import type { SetPaymentDataAndGoNext } from "../events";
import type { FlightMachineContext } from "../types";

export const paymentActions = {
  setPaymentData: assign(
    (ctx: FlightMachineContext, event: SetPaymentDataAndGoNext) => {
      ctx[ParentState.payment].paymentSessionToken = event.paymentSessionToken;
      ctx[ParentState.payment].paymentQuoteToken = event.paymentQuoteToken;
      return ctx;
    }
  ),
};
